module.exports = __webpack_public_path__ + "img/gym-tired.df14e89f.jpg";